module.exports = __webpack_public_path__ + "img/1_034.43ca04ec.jpg";